import "./profile.css";
import ProfilePagesWrapper from "./ProfilePagesWrapper";
import MyProfileHeader from "../MyProfileHeader/MyProfileHeader";
import NavigationHeader from "../NavigationHeader/NavigationHeader";

const ProfileLayout = () => {
  return (
    <div className="my-profile-wrapper container">
      <NavigationHeader />
      <div className="mt-16px">
        <MyProfileHeader />
      </div>
      <ProfilePagesWrapper />
    </div>
  );
};

export default ProfileLayout;
